import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { NavigationService } from './navigation.service';

export const Ng1NavigationModule = angular
  .module('control-room.angular.navigation-service', [])
  .factory('crNavigationService', downgradeInjectable(NavigationService));
